import {create, useStore} from 'zustand';
import {combine, persist} from 'zustand/middleware';
import {INSPECTOR_STORE_KEY} from '@/constants/storage';
import environment from '@/environment';

export type InspectorState = {
  isVisible: boolean;
  position: 'side' | 'bottom' | 'full';
  selectedDocumentId?: string;
};

export type InspectorStateMethods = {
  setVisible: (isVisible: boolean) => void;
  setPosition: (position: 'side' | 'bottom' | 'full') => void;
  setDocumentPreview: (documentId: string) => void;
};

export type InspectorStore = InspectorState & InspectorStateMethods;

const initialState: InspectorState = {
  isVisible: false,
  position: 'side',
  selectedDocumentId: undefined,
};

const InspectorStore = create(
  persist(
    combine<InspectorState, InspectorStateMethods>(initialState, set => ({
      setVisible: (isVisible: boolean) => set({isVisible}),
      setPosition: (position: 'side' | 'bottom' | 'full') => set({position}),
      setDocumentPreview: (selectedDocumentId: string) => set({selectedDocumentId}),
    })),
    {name: INSPECTOR_STORE_KEY},
  ),
);

const withDebugVisibility = (state: InspectorStore): InspectorStore => ({
  ...state,
  isVisible: environment.DEBUG && state.isVisible,
});

export const useInspector = <U,>(selector: (state: InspectorStore) => U) =>
  useStore(InspectorStore, state => selector(withDebugVisibility(state)));
